const selectedFamilyMember = useTeamUpSessionStorage('selected-family-member', 0)

export function useSelectedFamilyMemberState() {
  return selectedFamilyMember
}
